module.exports = __webpack_public_path__ + "static/media/squerryes-white.6a09f3c3.avif";